

import * as $$String from "rescript/lib/es6/string.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";

function toUpperCase(prim) {
  return prim.toUpperCase();
}

function slugify(str) {
  return str.replace(/^\s+|\s+$/g, "").toLowerCase().replace(/\s+/g, "-").replace(/-$/g, "");
}

var make = $$String.make;

var init = $$String.init;

var sub = $$String.sub;

var blit = $$String.blit;

var concat = $$String.concat;

var iter = $$String.iter;

var iteri = $$String.iteri;

var map = $$String.map;

var mapi = $$String.mapi;

var trim = $$String.trim;

var escaped = $$String.escaped;

var index = $$String.index;

var index_opt = $$String.index_opt;

var rindex = $$String.rindex;

var rindex_opt = $$String.rindex_opt;

var index_from = $$String.index_from;

var index_from_opt = $$String.index_from_opt;

var rindex_from = $$String.rindex_from;

var rindex_from_opt = $$String.rindex_from_opt;

var contains = $$String.contains;

var contains_from = $$String.contains_from;

var rcontains_from = $$String.rcontains_from;

var uppercase = $$String.uppercase;

var lowercase = $$String.lowercase;

var capitalize = $$String.capitalize;

var uncapitalize = $$String.uncapitalize;

var uppercase_ascii = $$String.uppercase_ascii;

var lowercase_ascii = $$String.lowercase_ascii;

var capitalize_ascii = $$String.capitalize_ascii;

var uncapitalize_ascii = $$String.uncapitalize_ascii;

var compare = $$String.compare;

var equal = $$String.equal;

var split_on_char = $$String.split_on_char;

var toInt = Belt_Int.fromString;

export {
  make ,
  init ,
  sub ,
  blit ,
  concat ,
  iter ,
  iteri ,
  map ,
  mapi ,
  trim ,
  escaped ,
  index ,
  index_opt ,
  rindex ,
  rindex_opt ,
  index_from ,
  index_from_opt ,
  rindex_from ,
  rindex_from_opt ,
  contains ,
  contains_from ,
  rcontains_from ,
  uppercase ,
  lowercase ,
  capitalize ,
  uncapitalize ,
  uppercase_ascii ,
  lowercase_ascii ,
  capitalize_ascii ,
  uncapitalize_ascii ,
  compare ,
  equal ,
  split_on_char ,
  toInt ,
  toUpperCase ,
  slugify ,
  
}
/* No side effect */
